document.addEventListener("DOMContentLoaded", function () {
  // ==========================================
  // MOBILE MENU
  // ==========================================

  const mobileMenuToggle = document.getElementById("mobileMenuToggle");
  const mobileMenu = document.getElementById("mobileMenu");
  const mobileMenuLinks = document.querySelectorAll(
    ".mobile-menu-nav > a, .mobile-nav-cta",
  );

  function toggleMobileMenu() {
    mobileMenu.classList.toggle("active");
    mobileMenuToggle.classList.toggle("active");
    document.body.style.overflow = mobileMenu.classList.contains("active")
      ? "hidden"
      : "";
  }

  function closeMobileMenu() {
    mobileMenu.classList.remove("active");
    mobileMenuToggle.classList.remove("active");
    document.body.style.overflow = "";
  }

  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener("click", toggleMobileMenu);
  }

  // Close on link click
  mobileMenuLinks.forEach((link) => {
    link.addEventListener("click", closeMobileMenu);
  });

  // Close on outside click
  document.addEventListener("click", function (e) {
    if (
      mobileMenu &&
      mobileMenu.classList.contains("active") &&
      !mobileMenu.contains(e.target) &&
      !mobileMenuToggle.contains(e.target)
    ) {
      closeMobileMenu();
    }
  });

  // Close on resize to desktop
  window.addEventListener("resize", function () {
    if (window.innerWidth >= 992 && mobileMenu.classList.contains("active")) {
      closeMobileMenu();
    }
  });

  // ==========================================
  // MOBILE DROPDOWNS
  // ==========================================

  const mobileDropdownToggles = document.querySelectorAll(
    ".mobile-dropdown-toggle",
  );

  mobileDropdownToggles.forEach((toggle) => {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = this.getAttribute("data-target");
      const targetMenu = document.getElementById(targetId);

      if (!targetMenu) return;

      const isOpen = targetMenu.classList.contains("active");

      // Close all open mobile dropdowns
      document
        .querySelectorAll(".mobile-dropdown-menu.active")
        .forEach((menu) => {
          menu.classList.remove("active");
        });
      document.querySelectorAll(".mobile-dropdown-toggle.open").forEach((t) => {
        t.classList.remove("open");
      });

      if (!isOpen) {
        targetMenu.classList.add("active");
        this.classList.add("open");
      }
    });
  });

  // ==========================================
  // DESKTOP DROPDOWN — delay close on mouseleave
  // ==========================================

  const desktopNavItems = document.querySelectorAll(
    ".desktop-menu .nav-item.has-dropdown",
  );

  desktopNavItems.forEach((item) => {
    let closeTimer;

    item.addEventListener("mouseenter", function () {
      clearTimeout(closeTimer);
    });

    item.addEventListener("mouseleave", function () {
      closeTimer = setTimeout(() => {
        // CSS handles visibility via :hover; this is a safety fallback
      }, 150);
    });
  });

  // (Service card click-to-expand removed — cards now use CSS hover only)

  // ==========================================
  // SMOOTH SCROLL
  // ==========================================

  const scrollLinks = document.querySelectorAll("a.scroll-link");

  scrollLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      const href = this.getAttribute("href");

      if (!href || href === "#") {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }

      // Handle same-page hash
      const hashIndex = href.indexOf("#");
      if (hashIndex === -1) return;

      const hash = href.slice(hashIndex);
      const targetElement = document.querySelector(hash);

      if (targetElement) {
        e.preventDefault();
        closeMobileMenu();

        const headerHeight =
          document.querySelector(".site-header").offsetHeight;
        const targetPosition =
          targetElement.getBoundingClientRect().top +
          window.scrollY -
          headerHeight;

        window.scrollTo({ top: targetPosition, behavior: "smooth" });
      }
    });
  });

  // ==========================================
  // HEADER SCROLL EFFECT
  // ==========================================

  const header = document.querySelector(".site-header");

  function handleScroll() {
    if (window.scrollY > 20) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  }

  window.addEventListener("scroll", handleScroll, { passive: true });
  handleScroll(); // Run on load

  // ==========================================
  // ABOUT SECTION — entrance animations + counter
  // ==========================================

  function animateCounter(el) {
    const target = parseInt(el.getAttribute("data-count"), 10);
    const suffix = el.getAttribute("data-suffix") || "";
    const duration = 1800; // ms
    const startTime = performance.now();

    function tick(now) {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      // ease-out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(eased * target) + suffix;
      if (progress < 1) requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  let countersStarted = false;

  const aboutObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const el = entry.target;

        if (el.classList.contains("about-animate")) {
          el.classList.add("in-view");
          aboutObserver.unobserve(el);
        }

        if (el.classList.contains("about-stats-row") && !countersStarted) {
          countersStarted = true;
          el.querySelectorAll(".about-stat-number[data-count]").forEach(
            (num) => {
              animateCounter(num);
            },
          );
        }
      });
    },
    { threshold: 0.2 },
  );

  document.querySelectorAll(".about-animate").forEach((el) => {
    aboutObserver.observe(el);
  });

  // ==========================================
  // INTERSECTION OBSERVER — fade-in animations
  // ==========================================

  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px -40px 0px",
  };

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const el = entry.target;
        el.style.opacity = "1";
        el.style.transform = "translateY(0)";
        observer.unobserve(el);

        // After transition completes, clear inline styles so CSS hover transform works
        const onEnd = (e) => {
          if (e.target !== el || e.propertyName !== "transform") return;
          el.style.opacity = "";
          el.style.transform = "";
          el.style.transition = "";
          el.removeEventListener("transitionend", onEnd);
        };
        el.addEventListener("transitionend", onEnd);
      }
    });
  }, observerOptions);

  const animatedElements = document.querySelectorAll(
    ".svc-card, .consultoria-card, .why-us-card, .testimonial-card, .client-item",
  );

  animatedElements.forEach((el, index) => {
    el.style.opacity = "0";
    el.style.transform = "translateY(20px)";
    el.style.transition = `opacity 0.5s ease ${index * 0.06}s, transform 0.5s ease ${index * 0.06}s`;
    observer.observe(el);
  });

  // ==========================================
  // BUTTON HOVER LIFT (keep existing behaviour)
  // ==========================================

  const buttons = document.querySelectorAll(
    ".btn-primary, .btn-secondary, .btn-cta, .btn-saiba-mais",
  );

  buttons.forEach((button) => {
    button.addEventListener("mouseenter", function () {
      this.style.transform = "translateY(-2px)";
    });
    button.addEventListener("mouseleave", function () {
      this.style.transform = "translateY(0)";
    });
  });

  // ==========================================
  // TESTIMONIALS SLIDER
  // ==========================================

  const tstSection = document.querySelector(".testimonials-section");

  if (tstSection) {
    const dataItems = Array.from(tstSection.querySelectorAll(".tst-item"));
    const grid = document.getElementById("tstGrid");
    const dotsWrap = document.getElementById("tstDots");
    const prevBtn = document.getElementById("tstPrev");
    const nextBtn = document.getElementById("tstNext");
    const total = dataItems.length;
    let current = 0;
    let animating = false;

    // Quote SVG (reused in each card)
    const quoteSVG = `<svg class="tst-quote-icon" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"></path><path d="M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"></path></svg>`;

    function buildCard(idx, isCenter) {
      const item = dataItems[idx];
      const initials = item.dataset.initials;
      const name = item.dataset.name;
      const role = item.dataset.role;
      const company = item.dataset.company;
      const quote = item.textContent.trim();
      const card = document.createElement("div");
      card.className = "tst-card" + (isCenter ? " is-center" : "");
      card.innerHTML = `
        ${quoteSVG}
        <p class="tst-quote-text">${quote}</p>
        <div class="tst-author">
          <div class="tst-avatar">${initials}</div>
          <div>
            <div class="tst-author-name">${name}</div>
            <div class="tst-author-role">${role}</div>
            <div class="tst-author-company">${company}</div>
          </div>
        </div>`;
      return card;
    }

    function renderSlide(animate) {
      if (animating) return;
      animating = true;

      const prev = (current - 1 + total) % total;
      const next = (current + 1) % total;
      const isMobile = window.innerWidth < 768;

      const doRender = () => {
        grid.innerHTML = "";
        if (isMobile) {
          grid.appendChild(buildCard(current, true));
        } else {
          grid.appendChild(buildCard(prev, false));
          grid.appendChild(buildCard(current, true));
          grid.appendChild(buildCard(next, false));
        }
        // Update dots
        Array.from(dotsWrap.children).forEach((dot, i) => {
          dot.className = "tst-dot" + (i === current ? " active" : "");
        });

        if (animate) {
          grid.style.transition = "opacity 0.35s ease, transform 0.35s ease";
          grid.style.opacity = "1";
          grid.style.transform = "translateY(0)";
        }
        animating = false;
      };

      if (animate) {
        grid.style.transition = "opacity 0.2s ease, transform 0.2s ease";
        grid.style.opacity = "0";
        grid.style.transform = "translateY(8px)";
        setTimeout(doRender, 200);
      } else {
        grid.style.opacity = "1";
        grid.style.transform = "translateY(0)";
        doRender();
      }
    }

    function goTo(idx) {
      current = ((idx % total) + total) % total;
      renderSlide(true);
    }

    // Build dots
    dataItems.forEach((_, i) => {
      const dot = document.createElement("button");
      dot.className = "tst-dot" + (i === 0 ? " active" : "");
      dot.setAttribute("aria-label", "Depoimento " + (i + 1));
      dot.addEventListener("click", () => goTo(i));
      dotsWrap.appendChild(dot);
    });

    prevBtn.addEventListener("click", () => goTo(current - 1));
    nextBtn.addEventListener("click", () => goTo(current + 1));

    // Re-render on resize (mobile ↔ desktop)
    window.addEventListener("resize", () => renderSlide(false));

    renderSlide(false);
  }

  // ==========================================
  // QUEM SOMOS — tab navigation
  // ==========================================

  const quemSomosPage = document.querySelector(".quem-somos");

  if (quemSomosPage) {
    const initialHash = window.location.hash;
    const originalScrollBehavior =
      document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = "auto";

    if (initialHash) {
      history.replaceState(null, null, " ");
      setTimeout(() => {
        history.replaceState(null, null, initialHash);
      }, 0);
    }

    const contentNavItems = quemSomosPage.querySelectorAll(".content-nav-item");
    const contentSections = quemSomosPage.querySelectorAll(".container-post");

    function showSection(targetId) {
      contentSections.forEach((section) => {
        if (section.id !== targetId) {
          section.style.opacity = "0";
          section.style.transform = "translateY(20px)";
          setTimeout(() => {
            section.style.display = "none";
          }, 300);
        }
      });

      const targetSection = quemSomosPage.querySelector(`#${targetId}`);
      if (targetSection) {
        targetSection.style.display = "block";
        setTimeout(() => {
          targetSection.style.opacity = "1";
          targetSection.style.transform = "translateY(0)";
        }, 50);
      }
    }

    function setActiveNavItem(targetId) {
      contentNavItems.forEach((item) => item.classList.remove("active"));
      const activeNavItem = quemSomosPage.querySelector(
        `.content-nav-item[href="#${targetId}"]`,
      );
      if (activeNavItem) activeNavItem.classList.add("active");
    }

    function navigateToSection(targetId, updateUrl = true) {
      setActiveNavItem(targetId);
      showSection(targetId);

      if (updateUrl) {
        const newUrl =
          window.location.pathname + window.location.search + "#" + targetId;
        window.history.pushState({ section: targetId }, "", newUrl);
      }
    }

    contentSections.forEach((section) => {
      section.style.transition = "opacity 0.3s ease, transform 0.3s ease";
      section.style.display = "none";
      section.style.opacity = "0";
      section.style.transform = "translateY(20px)";
    });

    function initializeFromUrl() {
      const hash = (initialHash || window.location.hash).replace("#", "");
      const validSections = ["sobre-nos", "depoimentos", "parceiros"];

      if (hash && validSections.includes(hash)) {
        navigateToSection(hash, false);
      } else {
        navigateToSection("sobre-nos", false);
      }

      setTimeout(() => {
        document.documentElement.style.scrollBehavior = originalScrollBehavior;
      }, 300);
    }

    window.addEventListener("popstate", function (e) {
      if (quemSomosPage && e.state && e.state.section) {
        navigateToSection(e.state.section, false);
      } else if (quemSomosPage) {
        const hash = window.location.hash.replace("#", "");
        const validSections = ["sobre-nos", "depoimentos", "parceiros"];
        navigateToSection(
          validSections.includes(hash) ? hash : "sobre-nos",
          false,
        );
      }
    });

    if (contentNavItems.length > 0) {
      initializeFromUrl();
    }

    contentNavItems.forEach((item) => {
      item.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const targetId = this.getAttribute("href").replace("#", "");
        navigateToSection(targetId, true);
      });
    });
  }
});
